import React from "react";
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

export type ChartSlice = { name: string; value: number; color: string };

export function StrategyPieChart({
  data,
  fixed = false,
  width = 260,
  height = 240,
  inlineLegend = false,
}: { data: ChartSlice[]; fixed?: boolean; width?: number; height?: number; inlineLegend?: boolean }) {
  const renderLegendText = (value: string, entry: any) => `${value} ${entry?.payload?.value ?? 0}%`;
  const sliceStroke = 'none';
  const sliceStrokeWidth = 0;
  return (
    <div className={fixed ? undefined : "w-full h-[240px]"}>
      {fixed ? (
        <PieChart width={width} height={height}>
          <Pie
            data={data}
            cx={width / 2}
            cy={height / 2}
            labelLine={false}
            outerRadius={Math.floor(Math.min(width, height) / 3.2)}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            stroke="none"
            strokeWidth={0}
            paddingAngle={0}
            isAnimationActive={false}
          >
            {data.map((entry, i) => (
              <Cell key={`slice-${i}`} fill={entry.color} stroke={sliceStroke} strokeWidth={sliceStrokeWidth} />
            ))}
          </Pie>
          {!inlineLegend && (
            <Legend
              formatter={renderLegendText}
              iconType="circle"
              iconSize={8}
              layout="horizontal"
              align="center"
              wrapperStyle={{
                paddingTop: "12px",
                fontSize: "13px",
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                textAlign: "center",
                gap: "8px 20px",
              }}
            />
          )}
        </PieChart>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
              stroke="none"
              strokeWidth={0}
              paddingAngle={0}
              isAnimationActive={true}
            >
              {data.map((entry, i) => (
                <Cell key={`slice-${i}`} fill={entry.color} stroke={sliceStroke} strokeWidth={sliceStrokeWidth} />
              ))}
            </Pie>
            {!inlineLegend && (
              <Legend
                formatter={renderLegendText}
                iconType="circle"
                iconSize={8}
                layout="horizontal"
                align="center"
                wrapperStyle={{
                  paddingTop: "12px",
                  fontSize: "13px",
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: "8px 20px",
                }}
              />
            )}
          </PieChart>
        </ResponsiveContainer>
      )}
      {inlineLegend && (
        <div className="strategy-inline-legend" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          textAlign: 'left',
          gap: '8px 16px',
          fontSize: '13px',
          paddingTop: '10px'
        }}>
          {data.map((s, i) => (
            <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.color, display: 'inline-block' }} />
              {s.name} {s.value}%
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default StrategyPieChart;
